module.exports = __webpack_public_path__ + "static-portal/img/5.6f7c9bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/5.jpg
// module id = 8FcD
// module chunks = 4